import React from "react";
import {withStyles} from "@material-ui/core/styles";

import projectsStyle
	from "assets/jss/material-kit-pro-react/views/sectionsSections/projectsStyle.js";
import GridItem from "../../components/Grid/GridItem";

import SVG from "react-inlinesvg";
import GridContainer from "../../components/Grid/GridContainer";

class LoadingCard extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			src: require('../../assets/svg/loading_1.svg')
		};
		switch (this.props.type) {
			case 2:
				this.state.src = require('../../assets/svg/loading_2.svg');
				break;
			case 3:
				this.state.src = require('../../assets/svg/loading_3.svg');
				break;
			case 4:
				this.state.src = require('../../assets/svg/loading_4.svg');
				break;
			case 5:
				this.state.src = require('../../assets/svg/loading_5.svg');
				break;
			case 6:
				this.state.src = require('../../assets/svg/loading_6.svg');
				break;
			case 7:
				this.state.src = require('../../assets/svg/loading_7.svg');
				break;
		}
	}

	render() {
		const {classes} = this.props;
		return (

			<div className={classes.container}>
				<GridContainer justify="center">
					<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
						<SVG src={this.state.src}
							 style={{
								 maxHeight: '500px', maxWidth: '100%'
							 }}
						/>
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

export default withStyles(projectsStyle)(LoadingCard)